import { RefObject } from 'react';

export const isInIframe = (): boolean => {
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
};

export const scrollTopIframe = (scrollElement: RefObject<HTMLDivElement>, delay = 0): void => {
  setTimeout(
    () =>
      scrollElement.current?.scrollIntoView({
        behavior: 'smooth',
      }),
    delay
  );
};
